const refreshJudgeMe = () => {
  if (
    !(window as any).jdgmCacheServer ||
    !(window as any).jdgm ||
    !(window as any).jdgm.$
  ) {
    setTimeout(refreshJudgeMe, 200);
    return;
  }

  document.querySelectorAll('.jdgm-widget').forEach((el) => {
    el.querySelectorAll('*').forEach((n) => n.remove());
  });

  // @ts-ignore
  window.jdgmCacheServer.reloadAll();
};

export default refreshJudgeMe;
